import React, { useEffect } from "react";
import Projects from '../../projects';
import HeaderContainer from "../header";

const HeaderNavProjects = (props) => {
    useEffect(() => {
        if (props.name === 'home') {
            const timer = setTimeout(() => {
                const element = document.getElementById("projectsHome");
                if (element) element.scrollIntoView({ block: "start", behavior: "smooth" });
            }, 400);
            return () => clearTimeout(timer);
        }
    }, [props.name]);

    return (
        <div id='projectsHome'>
            <HeaderContainer name='normalWhite' />
            <div className="containerProjects">
                <Projects name={props.name} />
            </div>
        </div>
    );
};

export default HeaderNavProjects;
